import Sweet16 from '~/pinkyellow/sweet16';

// --

export default (sixteen = 16.0, max) => {
  onBeforeMount(() => {
    Sweet16(sixteen, max);
  });
};
